import { ICustomViewTableDropDownOptions, IDataSheetViewDropDownOptions } from "csi/middleware/customView/options/CustomViewOptions";
import { ComponentItem } from "designSystem/types/component-item-types";
import { ICustomViewDataSheetOptions, ICustomViewDataSheetTableOptions } from "src/csi/middleware/customView/options/CustomViewOptions";

export enum SizeChartCompareType {
	NONE = "Size Chart Compare:None",
	INCREMENT = "Size Chart Compare:Increment",
	SHAPE = "Size Chart Compare:Shape",
}

export enum SizeChartDimensionFormatType {
	DEFAULT = "DEFAULT",
	ZERO = "0",
	ZERO_DOT_ONE_ZERO = "0.0",
	ZERO_DOT_TWO_ZERO = "0.00",
	ZERO_DOT_THREE_ZERO = "0.000",
	ZERO_DOT_FOUR_ZERO = "0.0000",
}

// Size chart dimension format options
export const SizeChartDimensionFormatOptions = [
	{ id: SizeChartDimensionFormatType.DEFAULT, res: "ViewPreferences_DefaultValue" },
	{ id: SizeChartDimensionFormatType.ZERO, name: "1" },
	{ id: SizeChartDimensionFormatType.ZERO_DOT_ONE_ZERO, name: "1.0" },
	{ id: SizeChartDimensionFormatType.ZERO_DOT_TWO_ZERO, name: "1.00" },
	{ id: SizeChartDimensionFormatType.ZERO_DOT_THREE_ZERO, name: "1.000" },
	{ id: SizeChartDimensionFormatType.ZERO_DOT_FOUR_ZERO, name: "1.0000" },
];

export enum SizeChartDisplayOptionsType {
	SELECTED_SIZES = "0",
	BASE_SIZE_ONLY = "1",
	ALL_SIZE = "2",
}

// Size chart options dropdown options
export const SizeChartDisplayOptions = [
	{ id: SizeChartDisplayOptionsType.SELECTED_SIZES, res: "CustomViewSizeChartDisplaySelectedSizes" },
	{ id: SizeChartDisplayOptionsType.BASE_SIZE_ONLY, res: "CustomViewSizeChartPrintBaseSize" },
	{ id: SizeChartDisplayOptionsType.ALL_SIZE, res: "CustomViewSizeChartDisplayAllSizes" },
];

export enum SizeChartDisplayType {
	ABSOLUTE = "Size Chart Display:Absolute",
	INCREMENT = "Size Chart Display:Increment",
	RELATIVE = "Size Chart Display:Relative",
}

export enum SizeChartUnitsType {
	CM = "Size Chart Units:CM",
	MM = "Size Chart Units:MM",
	INDEC = "Size Chart Units:IN - Decimal",
	INFRA = "Size Chart Units:IN - Fraction",
}

export enum SizeChartReviewPrintOldReviewOptionsType {
	PRINT_REVIEWS_DEFAULT = "0",
	PRINT_REVIEWS_ONE = "1",
	PRINT_REVIEWS_TWO = "2",
	PRINT_REVIEWS_THREE = "3",
	PRINT_REVIEWS_ALL = "-1",
}

export const SizeChartReviewPrintOldReviewOptions = [
	{ id: SizeChartReviewPrintOldReviewOptionsType.PRINT_REVIEWS_DEFAULT },
	{ id: SizeChartReviewPrintOldReviewOptionsType.PRINT_REVIEWS_ONE },
	{ id: SizeChartReviewPrintOldReviewOptionsType.PRINT_REVIEWS_TWO },
	{ id: SizeChartReviewPrintOldReviewOptionsType.PRINT_REVIEWS_THREE },
	{ id: SizeChartReviewPrintOldReviewOptionsType.PRINT_REVIEWS_ALL, res: "SelectAll" },
];

export interface ICustomViewTableSizeChartOptions extends ICustomViewDataSheetTableOptions {
	/** Compare: Shape or Compare: Increment, but if the custom view option is
		set to None, do not display anything for compare in the status bar.
	*/
	sizeChartCompare?: SizeChartCompareType;

	/** size chart dimension format */
	sizeChartDimensionFormat?: SizeChartDimensionFormatType;

	/** indicates method to use to display increment values - either increment, absolute, or relative */
	sizeChartDisplay?: SizeChartDisplayType;

	/** indicates if table showing all sizes */
	sizeChartDisplayAllSizes?: boolean;

	/** indicates if highlight should be blank */
	sizeChartHighlightBlank?: boolean;

	/** indicates if highlight actuals out of tolerance */
	sizeChartHighlightActualOutOfTolerance?: boolean;

	/** indicates if highlight blank Tolerance */
	sizeChartHighlightBlankTolerance?: boolean;

	/** indicates if highlight deltas out of tolerance */
	sizeChartHighlightDeltaOutOfTolerance?: boolean;

	/** indicates if highlight evaluation revised deltas out of tolerance */
	sizeChartHighlightRevisedDeltaOutOfTolerance?: boolean;

	/** indicates if table showing base size vs. all sizes */
	sizeChartPrintBaseSize?: boolean;

	/** units to use for displaying size chart numbers */
	sizeChartUnits?: SizeChartUnitsType;
}

export interface ICustomViewDataSheetSizeChartOptions extends ICustomViewDataSheetOptions {
	/** indicates print past reviews for all suppliers */
	reviewPrintAllSuppliers?: boolean;

	/** indicates print evaluation per size */
	reviewPrintEvaluationPerSize?: boolean;

	/** indicates print number of past reviews per size */
	reviewPrintOldReviews?: string;

	/** indicates print dimensions per sub size range */
	sizeChartPrintSubSizeRanges?: boolean;
}

export interface ICustomViewTableSizeChartDropDownOptions extends ICustomViewTableDropDownOptions {
	/** size chart compare options */
	readonly sizeChartCompareOptions: ComponentItem[];

	/** size chart dimension format options */
	readonly sizeChartDimensionFormatOptions: ComponentItem[];

	/** size chart increment display options */
	readonly sizeChartIncrementDisplayOptions: ComponentItem[];

	/** size chart display options */
	readonly sizeChartDisplayOptions: ComponentItem[];

	/** size chart unit options */
	readonly sizeChartUnitsOptions: ComponentItem[];
}

export interface ICustomViewDataSheetSizeChartDropDownOptions extends IDataSheetViewDropDownOptions {
	/** size chart print number of past reviews per size */
	readonly sizeChartReviewPrintOldReviewOptions: ComponentItem[];
}